<template>
    <div class="avatar" :style="style">
        <img :src="urlAvatar" class="f-ava__img">
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: {
        width:{default:56},
        height:{default:56}
    },
    data() {
        return {
            style: {
                width:this.width + 'px',
                height:this.height + 'px',
                borderRadius: 2 * this.width + 'px'
            }
        }
    },
    computed: {
        ...mapGetters({
            getUserInfo:"auth/getInfoUser",
            urlAvatar:'chat/getAvatarUrl',
        }
        ),
        getLatter() {
            if(this.getUserInfo === null)
                return ' '
            else if(this.getUserInfo.Detail.Name.length !== 0)
                return this.getUserInfo.Detail.Name[0];
            else
                return this.getUserInfo.User.Login[0]
        }
    }
}
</script>
<style lang="less" scoped>

</style>
